import { useMemo } from 'react';
import { getRecordViewParams } from 'utils/agendaRecord/agendaRecord.ts';
import type { GetValueFormItems, RecordsViewParam, ViewParameter } from 'types';

interface UseValueFormItemsProps {
  viewParameters: ViewParameter[];
  params?: RecordsViewParam[];
}

export const useValueFormItems = ({ viewParameters, params }: UseValueFormItemsProps): GetValueFormItems[] => {
  return useMemo(() => {
    const baseItems = getRecordViewParams(viewParameters);
    if (!params) return [];

    return params
      .map((param) => {
        const item = baseItems.find((i) => i.valueFormItemId === param.formItemId);
        if (!item) return null;

        return {
          ...item,
          valueDirect: param.valueDirect ? [String(param.valueDirect)] : null,
          valueSourceType: param.valueSourceType || null,
          valueFormItemId: param.valueFormItemId || null,
        };
      })
      .filter((item): item is GetValueFormItems => item !== null);
  }, [viewParameters, params]);
};
